module.exports = __webpack_public_path__ + "static/media/detail.5e2a3c0f.png";